if (!customElements.get('wearse-home-reviews')) {
  customElements.define('wearse-home-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-community-viewport]');
      this.controls = this.querySelector('[data-community-controls]');
      this.previous = this.querySelector('[data-community-previous]');
      this.next = this.querySelector('[data-community-next]');
      if (!this.viewport || !this.controls || !this.previous || !this.next) return;

      this.events?.abort();
      this.events = new AbortController();
      const { signal } = this.events;
      const update = () => this.updateControls();
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.viewport.addEventListener('scroll', update, { passive: true, signal });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-community-item]');
        const first = this.viewport.querySelector('[data-community-item]');
        if (item && first) this.viewport.scrollTo({ left: item.offsetLeft - first.offsetLeft, behavior: 'instant' });
      }, { signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.viewport);
      } else {
        window.addEventListener('resize', update, { signal });
      }
      this.updateControls();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }

    move(direction) {
      const item = this.viewport.querySelector('[data-community-item]');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'instant' : 'smooth' });
    }

    updateControls() {
      const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
      const left = this.viewport.scrollLeft;
      this.controls.hidden = maximum <= 2;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= maximum - 2;
    }
  });
}
